/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastnamerequired2Inputs */

const en_lastnamerequired2 = /** @type {(inputs: Lastnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name is required`)
};

const de_lastnamerequired2 = /** @type {(inputs: Lastnamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Last name is required" |
*
* @param {Lastnamerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const lastnamerequired2 = /** @type {((inputs?: Lastnamerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastnamerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lastnamerequired2(inputs)
	return de_lastnamerequired2(inputs)
});
export { lastnamerequired2 as "lastNameRequired" }